import angular from 'angular';

import { MERCHANT_PORTAL_API_BASE_URL } from "../../core/main/controller/environment";

const base = `${MERCHANT_PORTAL_API_BASE_URL}/portal/merchants/:merchantId/settlements/`;
const endpoint = `${base}:settlementId`;
const endpointList = `${endpoint}/items`;
const endpointSummaryList = `${endpoint}/summary`;
const baseOnlineCard = `${MERCHANT_PORTAL_API_BASE_URL}/portal/merchants/:merchantId/online-card-settlements/`;
const endpointOnlineCard = `${baseOnlineCard}:uuid`;
const endpointOnlineCardList = `${endpointOnlineCard}/transactions`;
const endpointOnlineCardSummaryList = `${endpointOnlineCard}/brief`;
const endpointOnlineCardSummarySettlement = `${endpointOnlineCard}/invoice`;
const endpointOnlineCardSettlementEnabled = `${MERCHANT_PORTAL_API_BASE_URL}/portal/merchants/:merchantId/online-card-settlements-check-enabled`;
const endpointMerchantSettlementStatus = `${base}status`;
const endpointReservesStatus = `${base}reserves`;

const getMerchantBaseUrl = (merchantId) => base.replace(/\:merchantId/, merchantId)
const getMerchantOnlineCardBaseUrl = (merchantId) => baseOnlineCard.replace(/\:merchantId/, merchantId)
const formatDate = function(date) {
    // month is zero based, so we need to add 1
    return date && date.getFullYear() + "-" + (("0" + (date.getMonth() + 1)).slice(-2)) + "-" + (("0" + date.getDate()).slice(-2));
};

function addChannelParam(channel = "") {
    return channel ? `&channel=${channel}` : ""
}

export const getExportCsvUrl = (merchantId, settlementId, source) =>
    `${getMerchantBaseUrl(merchantId)}${settlementId}/export?source=${source}`
export const getSummaryExportCsvUrl = (merchantId, settlementId, source) =>
    `${getMerchantBaseUrl(merchantId)}${settlementId}/summary?source=${source}`
export const getDetailExportCsvUrlForDates = (merchantId, fromDate, toDate, channel) =>
     `${getMerchantBaseUrl(merchantId)}export?fromDate=${formatDate(fromDate)}&toDate=${formatDate(toDate)}${addChannelParam(channel)}`
export const getSummaryExportCsvUrlForDates = function(merchantId, fromDate, toDate, channel) {
    return `${getMerchantBaseUrl(merchantId)}summary?fromDate=${formatDate(fromDate)}&toDate=${formatDate(toDate)}${addChannelParam(channel)}`;
}
export const getOnlineCardExport = (merchantId, uuid, reportType) =>
    `${getMerchantOnlineCardBaseUrl(merchantId)}${uuid}/export?reportType=${reportType}`

export const Settlement = {
    getExportCsvUrl,
    getSummaryExportCsvUrl,
    getDetailExportCsvUrlForDates,
    getSummaryExportCsvUrlForDates,
    getOnlineCardExport
}
export default Settlement

angular.module("merchant.application.main").factory("merchant.application.main.factory.settlement", [
    "$resource",
    function($resource) {
        const resource = $resource(endpoint);
        const resourceList = $resource(endpointList);
        const resourceSummaryList = $resource(endpointSummaryList);
        const resourceOnlineCard = $resource(baseOnlineCard)
        const resourceOnlineCardList = $resource(endpointOnlineCardList);
        const resourceOnlineCardSummaryList = $resource(endpointOnlineCardSummaryList);
        const resourceOnlineCardSummarySettlement = $resource(endpointOnlineCardSummarySettlement);
        const resourceOnlineCardSettlementEnabled = $resource(endpointOnlineCardSettlementEnabled);
        const resourceMerchantSettlementStatus = $resource(endpointMerchantSettlementStatus);
        const resourceReservesStatus = $resource(endpointReservesStatus);

        const expose = {};

        expose.read = function(parameters, success, error) {
            resource.get(parameters, success, error);
        };

        expose.readList = function(parameters, success, error) {
            resourceList.get(parameters, success, error);
        };

        expose.readSummaryList = function(parameters, success, error) {
            resourceSummaryList.get(parameters, success, error);
        };

        expose.readOnlineCard = function(parameters, success, error) {
            resourceOnlineCard.get(parameters, success, error);
        };

        expose.readOnlineCardList = function(parameters, success, error) {
            resourceOnlineCardList.get(parameters, success, error);
        };

        expose.readOnlineCardSummaryList = function(parameters, success, error) {
            resourceOnlineCardSummaryList.get(parameters, success, error);
        };

        expose.readOnlineCardSummarySettlement = function(parameters, success, error) {
            resourceOnlineCardSummarySettlement.get(parameters, success, error);
        };

        expose.readOnlineCardSettlementEnabled = function(parameters, success, error) {
            parameters.merchantId && resourceOnlineCardSettlementEnabled.get(parameters, success, error);
        }

        expose.readSettlementStatus = function(parameters, success, error) {
            resourceMerchantSettlementStatus.get(parameters, success, error);
        }

        expose.readReservesStatus = function(parameters, success, error) {
            resourceReservesStatus.get(parameters, success, error);
        }

        expose.getExportCsvUrl = getExportCsvUrl
        expose.getSummaryExportCsvUrl = getSummaryExportCsvUrl
        expose.getDetailExportCsvUrlForDates = getDetailExportCsvUrlForDates
        expose.getSummaryExportCsvUrlForDates = getSummaryExportCsvUrlForDates
        expose.getOnlineCardExport = getOnlineCardExport

        return expose;
    }
]);
